import React from 'react';
import { Link } from 'react-router-dom';
import '../../../global.css';
import Navbar from '../../../components/Navbar';
import SiteFooter from '../../../components/SiteFooter';
import NeuralCanvas from '../../../components/NeuralCanvas';
import { useSEO } from '../../../hooks/useSEO';
import safetyHero from '../../../assets/images/transport.jpeg'; // Import your local image

export default function Safety() {
  useSEO({
    title: 'Safety & Security Solutions',
    description: 'AI that keeps African communities safe — incident routing, threat detection, and multilingual emergency response built for African cities.',
    path: '/solutions/safety',
  });
  return (
    <>
      <NeuralCanvas />
      <div className="neural-page">
      <Navbar />

      {/* Hero */}
      <div style={{ borderBottom: '1px solid var(--line)', padding: '80px 0 72px' }}>
        <div style={{ maxWidth: 'var(--maxw)', margin: '0 auto', padding: '0 var(--pad-x)' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--accent)', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 20 }}>SOLUTION · SAFETY & SECURITY</div>
          <div className="sol-hero-grid">
            <div>
              <h1 style={{ fontSize: 'clamp(32px, 5vw, 52px)', fontWeight: 400, letterSpacing: '-0.04em', lineHeight: 1.05, marginBottom: 20 }}>
                Keeping communities<br /><span style={{ color: 'var(--fg-mid)', fontWeight: 300 }}>safe, in real time.</span>
              </h1>
              <p style={{ fontSize: 16, color: 'var(--fg-mid)', lineHeight: 1.7, maxWidth: 480, marginBottom: 32 }}>
                When something happens in Lagos, Nairobi, or Accra, the right help needs to arrive fast.
                Cybernate processes thousands of safety signals every second — in any language — and routes
                the right response to the right place before situations escalate.
              </p>
              <div style={{ display: 'flex', gap: 12 }}>
                <Link to="/signup" className="btn btn-primary">Get started →</Link>
                <Link to="/developers" className="btn btn-ghost">Developer platform</Link>
              </div>
            </div>
            {/* <div style={{ background: 'linear-gradient(135deg, #0C0C14 0%, #0A1020 60%, #0C1828 100%)', border: '1px solid var(--line)', borderRadius: 'var(--r-lg)', minHeight: 320, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translate(-50%, -50%)', width: 240, height: 240, background: 'radial-gradient(circle, rgba(139,124,255,0.12) 0%, transparent 70%)', borderRadius: '50%', pointerEvents: 'none' }} />
              <div style={{ textAlign: 'center', position: 'relative', zIndex: 1, padding: 32 }}>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" style={{ marginBottom: 16, opacity: 0.5 }}>
                  <path d="M12 3L20 6V12C20 16.5 16.5 20 12 21C7.5 20 4 16.5 4 12V6L12 3Z" stroke="var(--accent)" strokeWidth="1.2"/>
                  <circle cx="12" cy="12" r="2.2" fill="var(--accent)"/>
                </svg>
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--fg-dim)', letterSpacing: '0.14em', textTransform: 'uppercase' }}>Photo coming soon</div>
              </div>
            </div> */}
            <div style={{ padding: '56px 0 0' }}>
              <div style={{ maxWidth: 'var(--maxw)', margin: '0 auto', padding: '0 var(--pad-x)' }}>
                <div style={{
                  width: '100%',
                  height: 'clamp(220px, 42vw, 480px)',
                  borderRadius: 'var(--r-lg)',
                  overflow: 'hidden',
                  border: '1px solid var(--line)',
                  background: 'var(--bg-1)',
                }}>
                  <img
                    // src="https://images.unsplash.com/photo-1508971344143-1c0e7cdbf0b9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c2FmZXR5JTIwYWxlcnR8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=800&q=60"
                    src={safetyHero}
                    alt="Mobile money and financial access across Africa"
                    style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ borderBottom: '1px solid var(--line)', padding: '40px 0', background: 'var(--bg-1)' }}>
        <div className="sol-stats-grid" style={{ maxWidth: 'var(--maxw)', margin: '0 auto', padding: '0 var(--pad-x)' }}>
          {[['2.4M', 'Signals processed monthly'], ['94ms', 'Avg triage latency'], ['99.1%', 'Routing accuracy'], ['18', 'African languages']].map(([n, l], i) => (
            <div key={n} style={{ padding: '24px 32px', borderRight: i < 3 ? '1px solid var(--line)' : 'none' }}>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 28, fontWeight: 500, letterSpacing: '-0.04em', color: 'var(--fg)', marginBottom: 6 }}>{n}</div>
              <div style={{ fontSize: 12, color: 'var(--fg-dim)' }}>{l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ═══════════════════════════════════════════════════
          PHOTO SECTION — uncomment when image is ready.
          Replace src with your Unsplash URL.
          Tip: append ?w=1400&q=85&fit=crop to any Unsplash URL.
          ═══════════════════════════════════════════════════ */}
      {/*
      <div style={{ padding: '56px 0 0' }}>
        <div style={{ maxWidth: 'var(--maxw)', margin: '0 auto', padding: '0 var(--pad-x)' }}>
          <div style={{
            width: '100%',
            height: 'clamp(220px, 42vw, 480px)',
            borderRadius: 'var(--r-lg)',
            overflow: 'hidden',
            border: '1px solid var(--line)',
            background: 'var(--bg-1)',
          }}>
            <img
              src="YOUR_IMAGE_URL_HERE"
              alt="Community safety and emergency response across African cities"
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
              loading="lazy"
            />
          </div>
        </div>
      </div>
      */}

      {/* Use cases */}
      <div style={{ maxWidth: 'var(--maxw)', margin: '0 auto', padding: '72px var(--pad-x)' }}>
        <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--fg-dim)', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 16 }}>What you can build</div>
        <h2 style={{ fontSize: 32, fontWeight: 400, letterSpacing: '-0.03em', marginBottom: 48 }}>Safety applications<br /><span style={{ color: 'var(--fg-mid)', fontWeight: 300 }}>for African cities.</span></h2>
        <div className="sol-features-grid">
          {[
            { title: 'Incident triage', desc: 'Automatically classify incoming safety reports by severity and type. Route to police, medical, fire, or civil response teams — in any African language.' },
            { title: 'USSD alert systems', desc: 'Send and receive safety alerts over 2G/3G using USSD. Cybernate handles the NLP layer, you own the integration.' },
            { title: 'Community monitoring', desc: 'Process social media, WhatsApp messages, and community reports to detect emerging threats before they escalate.' },
            { title: 'Evidence analysis', desc: 'Analyze CCTV footage, incident photos, and documents to support law enforcement investigations. Models fine-tuned on African scenes.' },
            { title: 'Multi-language dispatch', desc: 'A dispatcher in Lagos handles reports in Yoruba, Igbo, and Hausa simultaneously. Cybernate translates and transcribes in real time.' },
            { title: 'Post-incident reporting', desc: 'Generate structured incident reports automatically from voice notes, chat logs, and officer observations.' },
          ].map(u => (
            <div key={u.title} style={{ padding: '24px', background: 'var(--bg-1)', border: '1px solid var(--line)', borderRadius: 'var(--r-md)' }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--fg)', marginBottom: 8 }}>{u.title}</div>
              <div style={{ fontSize: 13, color: 'var(--fg-dim)', lineHeight: 1.65 }}>{u.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div style={{ borderTop: '1px solid var(--line)', padding: '64px 0', background: 'var(--bg-1)' }}>
        <div style={{ maxWidth: 560, margin: '0 auto', textAlign: 'center', padding: '0 var(--pad-x)' }}>
          <h2 style={{ fontSize: 28, fontWeight: 400, letterSpacing: '-0.03em', marginBottom: 12 }}>Start building safer communities.</h2>
          <p style={{ fontSize: 14, color: 'var(--fg-mid)', marginBottom: 28 }}>Free to start. No credit card required. Works across all African regions.</p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <Link to="/signup" className="btn btn-primary btn-lg">Get started →</Link>
            <Link to="/developers" className="btn btn-ghost btn-lg">Developer docs</Link>
          </div>
        </div>
      </div>

      <SiteFooter />
      </div>
    </>
  );
}
